import React from 'react'
import { Link } from "react-router-dom";
import SliderHomeGallery from '../../component/slidercomponent/SliderHomeGallery';


const HomeGallery = () => {
    return (
        <>

            <div className="instagram-banner fix section-padding pt-0">
                <div className="instagram-wrapper">
                    {/* <h4 className="text-center wow fadeInUp" data-wow-delay=".3s">School Gallery</h4> */}
                    
                    <div className="swiper instagram-banner-slider">
                        <div className="container">
                            <SliderHomeGallery />
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default HomeGallery